// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail_detail__Za_Hc","title":"detail_title__1YQXs","value":"detail_value__2ov1q"};